import { ADMIN_PREFIX } from "@cti-workspace/helpers";
import { postApi } from "./api";

export default async function addPDFTemplate(pdfTemplate) {
  const url = `/${ADMIN_PREFIX}/addPdfTemplates`;
  return postApi(url, pdfTemplate);
}
